import { useMedia } from "react-use";
import solutrans from "../assets/images/solutrans.png";
import solutransBg from "../assets/images/solutrans-bg.png";

const Banner = () => {
  const isWide = useMedia("(min-width: 640px)");

  return (
    <section className="bg-allsafe-grey flex justify-center">
      <img
        src={isWide ? solutransBg : solutrans}
        alt="imageSource"
        className="object-fill grow"
      />
    </section>
  );
};

export default Banner;
